module.exports = "/images/default_profile_picture.png?2fa7c55cf7e02d4b549bad95084e483d";